import Vue from "vue";
import VueI18n from "vue-i18n";

// Languages
import en from "./en";
import es from "./es";
// import de from "./de";
// import fr from "./fr";

Vue.use(VueI18n);

const availableLanguages = {
  en: en.language,
  es: es.language
};

const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "en",
  fallbackLocale: "en",
  messages: {
    es,
    en
  }
});

export { i18n, availableLanguages };
